import axios from "axios";

const instance = axios.create({
    baseURL: 'https://us-central1-dinebahar-mern.cloudfunctions.net/api' // THE API (cloud function) URL
});

export default instance;

// http://localhost:5001/dinebahar-mern/us-central1/api